import { forwardRef } from 'react';

import ChainIcon from '@/components/ChainIcon';
import { Button, ButtonProps } from '@/components/shadcn/ui/button';
import { useLtcWallet } from '@/networks/btc-like/ltc';
import { cn } from '@/utils';
import { truncateMidAddressInputValue } from '@/utils/truncateAddress';

export const ConnectedLtcWalletButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, ...props }, ref) => {
    const { address } = useLtcWallet();
    const resultAddress = truncateMidAddressInputValue(address!);

    return (
      <Button
        ref={ref}
        size="sm"
        variant="secondary"
        className={cn('font-roboto rounded-xl font-bold', className)}
        {...props}
      >
        {children || (
          <div className="flex items-center gap-1 text-sm sm:gap-2">
            <ChainIcon src="/chains/litecoin.svg" />
            <div className="hidden sm:block">{resultAddress}</div>
          </div>
        )}
      </Button>
    );
  }
);

ConnectedLtcWalletButton.displayName = 'ConnectedLtcWalletButton';
